const vueEls = document.querySelectorAll('[id^="featuredCollection-"]');

if(vueEls.length){

  vueEls.forEach(function(item) {

    const FeaturedCollection = {
      store, 
      name: 'FeaturedCollection'+item.id,
      delimiters: ['${', '}'],
      compilerOptions:{
        isCustomElement: tag => ['slider-component'].includes(tag)
      },
      data() {
    
    
          return {
            prueba: 'prueba'
          }
    
      },
      created() {
    
      },
      methods:{
    
        addToCart(id, qty){
    
    
    
          store.dispatch('addToCart', {id, qty})
          .then((response) => {
    
          })
        },
        updateCart(id, qty) {
          store.dispatch('addToCart', {id, qty})
          .then((response) => {
    
          })
        }
    
      }
    
    }
    
    const FeaturedCollectionApp = Vue.createApp(FeaturedCollection)
    mountVueComponent(FeaturedCollectionApp, 'custom-price')
    mountVueComponent(FeaturedCollectionApp, 'custom-price-a')
    
    
    
    // document.querySelectorAll('.product-card').forEach(element => {
    //   FeaturedCollectionApp.mount()
    // });
    
    
    
    FeaturedCollectionApp.mount(document.getElementById(item.id))
    FeaturedCollectionApp.use(store)

  })

}

